import { Amount, ProductCharging, ProductChargingMode } from '@mews-commander/data-access';
import { Typography, Card, CardContent, Highlight, Stack } from '@optimus-web/core';
import { LocalizedCurrencyValue, LocalizedEnum, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { SpacedMultiplicationSign } from '@mews-commander/ui';

interface ProductSummaryProps {
    quantity: number;
    price: Amount;
    chargingMode: ProductChargingMode;
}

export const ProductSummary: React.FC<ProductSummaryProps> = ({ quantity, price, chargingMode }) => (
    <Card overflowHidden>
        <CardContent padding="200" highlighted>
            <Stack distribution="space-between" itemAlignment="center">
                <Stack vertical>
                    <Typography textStyle="bodyMediumStrong" as="div">
                        {quantity}
                        {SpacedMultiplicationSign}
                        <LocalizedCurrencyValue value={price} />
                    </Typography>

                    <Typography textStyle="bodySmall" variant="secondary" as="div">
                        <LocalizedText textKey={TextKey.Charged} />
                        {UnicodeEntity.NoBreakSpace}
                        {/* ProductCharging and ProductChargingMode are same enums just generated twice */}
                        <LocalizedEnum prefix="ProductCharging" value={chargingMode as unknown as ProductCharging} />
                    </Typography>
                </Stack>
                <Highlight size="small">
                    <LocalizedCurrencyValue
                        value={{
                            value: quantity * price.value,
                            currency: price.currency,
                        }}
                    />
                </Highlight>
            </Stack>
        </CardContent>
    </Card>
);
